import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getLangPath } from '../../router/langRoutes';

interface LanguageGuardProps {
  children: React.ReactNode;
  redirectTo?: string;
}

export default function LanguageGuard({ children, redirectTo }: LanguageGuardProps) {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (i18n.language === 'lv') {
      const defaultRedirect = redirectTo || getLangPath('home', i18n.language);
      navigate(defaultRedirect, { replace: true });
    }
  }, [i18n.language, navigate, redirectTo]);

  if (i18n.language === 'lv') {
    return null;
  }

  return <>{children}</>;
}